module.exports = __webpack_public_path__ + "static/media/gpbook-logo.06d65671.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Pricing/gpbook-logo.svg
// module id = 140
// module chunks = 0